import { EventEmitter, Injectable, Output } from '@angular/core';
import { AppMenu } from '../../../objects/app-menu';
import { RouteInfo } from './sidebar.metadata';

@Injectable({
  providedIn: 'root'
})
export class FinexSidebarService {

  sideBarEmitter = new EventEmitter();
	menuItems: RouteInfo[] = [];

	@Output() miniSidebar: EventEmitter<string> = new EventEmitter();
	@Output() changeMenu: EventEmitter<RouteInfo[]> = new EventEmitter();

	setMenuItems(lstNewMenuItems: RouteInfo[]) {
		this.menuItems = lstNewMenuItems;
		this.changeMenu.emit(this.menuItems);
	} 
}
